// src/dokumentklassen/rechnung/mwstSpalten.js
// Leitet die MwSt-Spalten für Korrektur-Tabelle und Excel-Export dynamisch aus den in dieser
// Installation gültigen Steuersätzen ab (siehe Steuersaetze.js), statt sie hart auf 0/7/19%
// zu verdrahten. Reihenfolge = STEUERSAETZE-Reihenfolge = Spaltenreihenfolge.
import { STEUERSAETZE } from './Steuersaetze';

export function getMwstSpalten() {
  return STEUERSAETZE.map((satz) => ({
    key: satz, // passt zu rechnung.mwst_betrag_eur[satz]
    label: `MwSt ${satz}%`,
  }));
}

export default getMwstSpalten;